import React from 'react';
import { MoreVertical, Settings, Copy, Trash2 } from 'lucide-react';

export default function FilterActionsMenu({
    filter,
    isOpen,
    isLastTwo,
    onToggle,
    onRename,
    onDuplicate,
    onDelete,
}) {
    return (
        <div className="relative">
            <button
                type="button"
                aria-label="Filter actions"
                onClick={(e) => {
                    e.stopPropagation();
                    onToggle();
                }}
                className={`p-1.5 rounded-md transition-colors ${isOpen ? 'bg-gray-100 text-gray-900' : 'text-gray-400 hover:text-gray-600 hover:bg-gray-100'}`}
            >
                <MoreVertical className="w-4 h-4" />
            </button>

            {/* Dropdown Menu */}
            {isOpen && (
                <div className={`absolute right-0 w-48 bg-white rounded-lg shadow-xl border border-gray-100 z-50 animate-in fade-in zoom-in-95 duration-100 origin-top-right overflow-hidden ${isLastTwo ? 'bottom-full mb-2 origin-bottom-right' : 'mt-2 origin-top-right'}`}>
                    <div className="py-1">
                        <button
                            type="button"
                            onClick={() => onRename(filter)}
                            className="w-full text-left px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2"
                        >
                            <Settings className="w-4 h-4 text-gray-400" />
                            Settings
                        </button>
                        <button
                            type="button"
                            onClick={() => onDuplicate(filter)}
                            className="w-full text-left px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2"
                        >
                            <Copy className="w-4 h-4 text-gray-400" />
                            Duplicate filter
                        </button>
                        <div className="h-px bg-gray-100 my-1"></div>
                        <button
                            type="button"
                            onClick={() => onDelete(filter.id)}
                            className="w-full text-left px-4 py-2.5 text-sm text-red-600 hover:bg-red-50 flex items-center gap-2"
                        >
                            <Trash2 className="w-4 h-4 text-red-500" />
                            Delete filter
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}
